import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { LoggingMessageService } from './logging-message.service';

import moment from 'moment';
// use date-fns package instead of Moment to greatly reduce package size


@Injectable({
    providedIn: 'root'
  })
export class AuthService {
    private userEmail: string;
    private ACCESS_TOKEN_ID = environment.AccessTokenID;
    private TOKEN_EMAIL = environment.TokenEmail;
    private TOKEN_ID_EXPIRES = environment.TokenIDExpires;
    private SUBSCRIPTION_SELECTED = environment.SubscriptionSelected;
    private IS_PRODUCTION = environment.production;


    constructor(private http: HttpClient, private logger: LoggingMessageService) {

    }

    getAccessToken(): any {
        let token: any = {};
        const tokenString = sessionStorage.getItem(this.ACCESS_TOKEN_ID);
        const user = this.getTokenEmail();
        //this.logger.debug('auth.service', 'getAccessToken', this.getSubscription(), this.getSubscriptionsAvailable(token),`Token: ${tokenString}`, '');
        if (tokenString) {
            token = JSON.parse(tokenString);
        }
        return token;
    }

    getTokenEmail(): string {
      let tokenEmail: string;
      if (this.userEmail) {
        tokenEmail = this.userEmail;
      } else {
        tokenEmail = sessionStorage.getItem(this.TOKEN_EMAIL);
        this.userEmail = tokenEmail;
      }
      return tokenEmail;
    }

    getSubscription(): number {
                return -1;
    }

    getSubscriptionsAvailable(token): string {
        const subs = (token && token.subscriptionsavailable) ? token.subscriptionsavailable : '';
        return subs;
    }

    logout() {
        sessionStorage.removeItem(this.ACCESS_TOKEN_ID);
        sessionStorage.removeItem(this.TOKEN_ID_EXPIRES);
        sessionStorage.removeItem(this.SUBSCRIPTION_SELECTED);
    }

    private isAccessTokenExpired(): boolean {
        const expiresAt = sessionStorage.getItem(this.TOKEN_ID_EXPIRES);
        if (expiresAt) {
            const expiryUtc = moment.utc(expiresAt, 'YYYY-MM-DD HH:mm:ss');
            const localExpiry = expiryUtc.local();
            const nowLocal = moment().local();
            const isTokenExpired = nowLocal.isAfter(localExpiry);
            if (isTokenExpired === true) {
                const now = nowLocal.format('YYYY-MM-DD HH:mm:ss');
                const exiry = localExpiry.format('YYYY-MM-DD HH:mm:ss');
                const user = this.getTokenEmail();
                this.logger.info('auth.service', 'isAccessTokenExpired', this.getSubscription(), this.getSubscriptionsAvailable(this.getAccessToken()), `IF Token Has Expired - Now: ${now}, Token Expiry: ${exiry}`, '');
            }
            return isTokenExpired;
        }
        return true;
    }

    public isUserLoggedIn(): boolean {
        if (this.IS_PRODUCTION === false) { return true; }

        const tokenHasExpired = this.isAccessTokenExpired();
        return !tokenHasExpired;
    }

}
